import RecursiveSelector from '@/components/RecursiveSelector';
import VuePhoneNumberInput from 'vue-phone-number-input';
import badgeStyleGroup from '../resources/badgeStyleGroup.json';
import showAlert from '@waypoint/vue-alert';

import userEscl from '../locales/es-CL/user.json';
import userEsmx from '../locales/es-MX/user.json';
import userEsco from '../locales/es-CO/user.json';
import userEnus from '../locales/en-US/user.json';
import userCrudModal from '../user/modalCrudUser/modalCrudUserHandler';

import axios from 'axios';

import LogService from '../services/LogService';
import Container from 'typedi';
import Multiselect from 'vue-multiselect';
export default {
  name: 'admin-usuarios',
  components: {
    Multiselect,
    RecursiveSelector,
    VuePhoneNumberInput,
  },
  i18n: {
    messages: {
      'es-CL': {
        user: userEscl,
      },
      'es-MX': {
        user: userEsmx,
      },
      'es-CO': {
        user: userEsco,
      },
      'en-US': {
        user: userEnus,
      },
    },
  },
  data() {
    return {
      loggedUserGroupName: '',
      isCrudBusy: false,
      rowsExcelTranform: [],
      rowsExcel: null,
      fileExcel: null,
      isMassiveActive: false,
      isCreateMode: false,
      badges: badgeStyleGroup,
      dataAccess: null,
      users: [],
      groups: [],
      editMode: false,
      selectedUser: {
        id: null,
        profile: null,
        firstName: null,
        lastName: null,
        username: null,
        phone: null,
        email: null,
        password: null,
        repeatPassword: null,
        showPassword: false,
        showPasswordRepeat: false,
        isOwner: false,
      },
      checkFields: {
        profile: true,
        firstName: true,
        lastName: true,
        username: true,
        limitCharacters: true,
        spaceInUsername: true,
        phone: true,
        email: true,
        invalidEmail: true,
        password: true,
        repeatPassword: true,
        notMatchRepeatPassword: true,
      },
      isUserCheck: true,
      hoverInfoPass: false,
      phoneNumberValid: false,
      isMainPageBussy: false,
      openGroups: false,
      profileExist: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      filterKeyword: '',
      defaultCountry: 'CL',
      preferedCountries: ['CL', 'MX', 'US', 'CO'],
      selectedAllUsers: false,
      usersSelected: [],
      logService: null,
    };
  },
  created() {
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    checkUsers() {
      if (this.selectedAllUsers) {
        this.checkAllUsers();
      } else {
        this.unCheckAllUsers();
      }
    },
    checkAllUsers() {
      this.usersSelected = [];
      for (const user of this.filtered) {
        if (user.groupName != 'Dueño de la cuenta') {
          this.usersSelected.push(user.id);
        }
      }
    },
    unCheckAllUsers() {
      this.usersSelected = [];
    },
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      await this.getGroups();
      await this.getUsers();
      this.isMainPageBussy = false;
    },
    async getUsers() {
      const currentUserId = this.$store.getters.loggedUser.idUser;
      try {
        this.logService.sendInfo({
          component: 'user',
          message: `getusers con la url /api/user?lastmileSimple=true`,
        });
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/user?lastmileSimple=true`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.users = response.data.data;
        this.users.forEach((user) => {
          user.fullName = user.firstName + ' ' + user.lastName;
          if (this.groups) {
            user.group = this.groups.find((group) => group.id === user.idGroup);
            if (user.group && user.group.name) {
              user.groupName = user.group.name;
            }
            if (user.id === currentUserId) {
              this.loggedUserGroupName = user.group.name;
            }
          }
          user.phoneNumber = user.phoneNumber != null ? user.phoneNumber.replace(/\s/g, '') : user.phoneNumber;
        });
        console.log(this.users);
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `getUsers fallo ${e.message}`,
        });
        console.log(e);
      }
    },
    async getGroups() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/client/userGroups`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        console.log(response.data.data);
        this.groups = response.data.data;
        this.groups.forEach((group) => {
          if (group.name === 'Dueño de la cuenta') {
            group.$isDisabled = true;
          }
        });
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `getGroups fallo ${e.message}`,
        });
        console.log(e);
      }
    },
    openModalCreate() {
      userCrudModal(false, true, false, null, this.groups, async () => {
        this.isMainPageBussy = true;
        await this.getUsers();
        this.isMainPageBussy = false;
      });
    },
    openUpdateModal(user) {
      userCrudModal(true, false, false, user, this.groups, async () => {
        this.isMainPageBussy = true;
        await this.getUsers();
        this.isMainPageBussy = false;
      });
    },
    openDeleteUser(user) {
      this.selectedUser = user;
      this.showModal('confirm-delete');
    },
    openMassDeleteModal() {
      this.showModal('confirm-mass-delete');
    },
    async massiveDelete() {
      try {
        this.closeModal('confirm-mass-delete');
        this.isMainPageBussy = true;
        const response = await axios.post(`${this.$store.getters.urlAPI}/api/user/massDelete`, this.usersSelected, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('user.successful.massDelete'), 'success');
          await this.getUsers();
          this.isMainPageBussy = false;
        }
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `massiveDelete fallo ${e.message}`,
          data: this.usersSelected,
        });
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('user.error.massDelete'), 'error');
      }
    },
    async processDelete(user) {
      try {
        this.closeModal('confirm-delete');
        this.isMainPageBussy = true;
        const response = await axios.delete(`${this.$store.getters.urlAPI}/api/user/${user.id}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(
            this.$t('common.modals.exitoTitulo'),
            this.$t('user.successful.delete', { fullName: user.fullName }),
            'success',
          );
          await this.getUsers();
          this.isMainPageBussy = false;
        }
      } catch (e) {
        this.logService.sendError({
          component: 'user',
          message: `delete del usuario ${user.id} fallo ${e.message}`,
        });
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('user.error.delete', { fullName: user.fullName }),
          'error',
        );
      }
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    getColorBackground(user) {
      if (this.badges[user.groupName]) {
        return (
          'background-color: transparent;color:' +
          this.badges[user.groupName].color +
          ';border:' +
          this.badges[user.groupName].border
        );
      }
      return 'background-color: transparent';
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
  },
  computed: {
    filtered() {
      if (this.filterKeyword) {
        return this.users.filter((item) => {
          if (item.username && item.username.toUpperCase().includes(this.filterKeyword.toUpperCase())) {
            return item;
          }
          if (item.fullName && item.fullName.toUpperCase().includes(this.filterKeyword.toUpperCase())) {
            return item;
          }
        });
      } else {
        return this.users;
      }
    },
    userField() {
      const common = {
        class: 'text-left',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'fullName',
          label: this.$t('user.fields.fullName'),
          ...common,
        },
        {
          key: 'username',
          label: this.$t('user.fields.username'),
          ...common,
        },
        {
          key: 'groupName',
          label: this.$t('user.fields.profile'),
          ...common,
        },
        {
          key: 'phoneNumber',
          label: this.$t('user.fields.phone'),
          ...common,
        },
        {
          key: 'email',
          label: this.$t('user.fields.email'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('user.fields.actions'),
          class: 'text-center',
        },
      ];
    },
  },
  watch: {},
};
